import _ from 'underscore';
import { LIVE_INIT, LIVE_UPDATE, LIVE_MATCH_UPDATE, LIVE_MATCH_INIT } from '../../sagas/actions';
import * as PopularActions from '../../actions/popular';
import * as LineActions from '../../actions/lines';
import headerOutcomeTypes from '../../components/grid/glossary/sport-outcome-headers.json';
export default function outcomesHeadersReducer(action, outcomes, matches, rates) {
    switch (action.type) {
        case PopularActions.SUCCESS_FETCH_POPULAR_MATCHES:
        case LineActions.SUCCESS_FETCH_LINE_HEADERS:
        case LineActions.SUCCESS_FETCH_SPORT_LINE_HEADERS:
        case LineActions.SUCCESS_FETCH_LEAGUE_LINE_HEADERS:
            if (action.data.outcomes) {
                return setAddedOutcomesHeaders(outcomes, action.data.outcomes.add);
            }
            break;
        case LIVE_INIT.SUCCESS:
        case LIVE_MATCH_INIT.SUCCESS:
        case LineActions.SUCCESS_FETCH_FULL_LINE:
            if (action.data.outcomes) {
                return setNewOutcomesHeaders(outcomes, matches, rates, action.data.outcomes.add);
            }
            break;
        case LIVE_UPDATE.SUCCESS:
        case LIVE_MATCH_UPDATE.SUCCESS:
            if (action.data.outcomes) {
                outcomes = updateOutcomesHeaders(outcomes, matches, rates, action.data.outcomes.remove);
                outcomes = setNewOutcomesHeaders(outcomes, matches, rates, action.data.outcomes.add);
            }
            if (action.data.rates) {
                outcomes = updateOutcomesHeaders(outcomes, matches, rates, action.data.rates.add);
                outcomes = updateOutcomesHeadersOnRateChange(outcomes, matches, rates, action.data.rates.change);
            }
            return outcomes;
        default:
            return outcomes;
    }
}
function setAddedOutcomesHeaders(outcomes, addedOutcomes) {
    if (addedOutcomes === undefined) {
        return outcomes;
    }
    for (var i = 0; i < addedOutcomes.length; i++) {
        var outcomeId = addedOutcomes[i].id;
        outcomes = outcomes.setIn([outcomeId, 'isHeader'], true);
    }
    return outcomes;
}
function setNewOutcomesHeaders(outcomes, matches, rates, newOutcomes) {
    if (newOutcomes === undefined) {
        return outcomes;
    }
    var calculatedOutcomes = [];
    var _loop_1 = function (i) {
        var outcomeId = newOutcomes[i].id;
        var outcome = outcomes.get(outcomeId);
        if (!outcome) {
            return "continue";
        }
        var outcomeType = outcome.get('type');
        var matchId = outcome.get('matchId');
        var match = matches.get(matchId);
        var realSportId = match.get('realSportId');
        var sportHeaders = headerOutcomeTypes[realSportId];
        if (!sportHeaders.includes(outcomeType)) {
            outcomes = outcomes.updateIn([outcomeId, 'isHeader'], function () { return false; });
            return "continue";
        }
        if (calculatedOutcomes.find(function (o) { return o.matchId === matchId && o.outcomeType === outcomeType; })) {
            return "continue";
        }
        var similarTypeMatchOutcomes = outcomes.filter(function (o) {
            return o.get('matchId') === matchId && o.get('type') === outcomeType;
        }).toArray();
        calculatedOutcomes.push({ matchId: matchId, outcomeType: outcomeType });
        var maxBalance = Number.POSITIVE_INFINITY;
        var mostBalancedOutcomeId = null;
        if (similarTypeMatchOutcomes.length === 1) {
            mostBalancedOutcomeId = similarTypeMatchOutcomes[0].get('id');
        }
        else {
            for (var j = 0; j < similarTypeMatchOutcomes.length; j++) {
                var id = similarTypeMatchOutcomes[j].get('id');
                outcomes = outcomes.updateIn([id, 'isHeader'], function () { return false; });
                var outcomeBalance = calculateOutcomeBalance(id, rates);
                if (outcomeBalance < maxBalance) {
                    maxBalance = outcomeBalance;
                    mostBalancedOutcomeId = id;
                }
            }
        }
        if (mostBalancedOutcomeId !== null) {
            outcomes = outcomes.updateIn([mostBalancedOutcomeId, 'isHeader'], function () { return true; });
        }
    };
    for (var i = 0; i < newOutcomes.length; i++) {
        _loop_1(i);
    }
    return outcomes;
}
function calculateOutcomeBalance(outcomeId, rates) {
    var outcomeRates = rates.filter(function (r) { return r.get('outcomeId') === outcomeId; }).toArray();
    if (outcomeRates.length === 0) {
        return Number.POSITIVE_INFINITY;
    }
    var factor1 = outcomeRates[0].get('value');
    var factor2 = outcomeRates[1].get('value');
    if (factor1 > 0 && factor2 > 0 && (factor1 > 1.0 || factor2 > 1.0)) {
        return Math.abs(1 / factor1 - (1 / factor1 + 1 / factor2 - 1) / 2 - 0.5);
    }
    return Number.POSITIVE_INFINITY;
}
function updateOutcomesHeadersOnRateChange(outcomes, matches, rates, rateChanges) {
    if (rateChanges === undefined) {
        return outcomes;
    }
    var changedRates = rates.filter(function (r) { return rateChanges[r.get('id')] !== undefined; });
    var matchIds = _.uniq(changedRates.map(function (r) { return r.get('matchId'); }).toArray());
    var _loop_2 = function (i) {
        var matchId = matchIds[i];
        var match = matches.get(matchId);
        var realSportId = match.get('realSportId');
        var sportHeaders = headerOutcomeTypes[realSportId];
        var matchOutcomes = outcomes
            .filter(function (o) { return o.get('matchId') === matchId && sportHeaders.includes(o.get('type')); })
            .groupBy(function (o) { return o.get('type'); });
        matchOutcomes.forEach(function (outcomeTypes) {
            var maxBalance = Number.POSITIVE_INFINITY;
            var mostBalancedOutcomeId = null;
            var outcomesArr = outcomeTypes.toArray();
            if (outcomesArr.length === 1) {
                mostBalancedOutcomeId = outcomesArr[0].get('id');
            }
            else {
                for (var i_1 = 0; i_1 < outcomesArr.length; i_1++) {
                    var id = outcomesArr[i_1].get('id');
                    outcomes = outcomes.updateIn([id, 'isHeader'], function () { return false; });
                    var outcomeBalance = calculateOutcomeBalance(id, rates);
                    if (outcomeBalance < maxBalance) {
                        maxBalance = outcomeBalance;
                        mostBalancedOutcomeId = id;
                    }
                }
            }
            if (mostBalancedOutcomeId !== null) {
                outcomes = outcomes.updateIn([mostBalancedOutcomeId, 'isHeader'], function () { return true; });
            }
        });
    };
    for (var i = 0; i < matchIds.length; i++) {
        _loop_2(i);
    }
    return outcomes;
}
function updateOutcomesHeaders(outcomes, matches, rates, entityCollection) {
    if (entityCollection === undefined) {
        return outcomes;
    }
    var matchIds = Array.from(new Set(entityCollection.map(function (ro) { return ro.matchId; })));
    var _loop_3 = function (i) {
        var matchId = matchIds[i];
        var match = matches.get(matchId);
        var realSportId = match.get('realSportId');
        var sportHeaders = headerOutcomeTypes[realSportId];
        var matchOutcomes = outcomes
            .filter(function (o) { return o.get('matchId') === matchId && sportHeaders.includes(o.get('type')); })
            .groupBy(function (o) { return o.get('type'); });
        matchOutcomes.forEach(function (outcomeTypes) {
            var maxBalance = Number.POSITIVE_INFINITY;
            var mostBalancedOutcomeId = null;
            var outcomesArr = outcomeTypes.toArray();
            if (outcomesArr.length === 1) {
                mostBalancedOutcomeId = outcomesArr[0].get('id');
            }
            else {
                for (var i_2 = 0; i_2 < outcomesArr.length; i_2++) {
                    var id = outcomesArr[i_2].get('id');
                    outcomes = outcomes.updateIn([id, 'isHeader'], function () { return false; });
                    var outcomeBalance = calculateOutcomeBalance(id, rates);
                    if (outcomeBalance < maxBalance) {
                        maxBalance = outcomeBalance;
                        mostBalancedOutcomeId = id;
                    }
                }
            }
            if (mostBalancedOutcomeId !== null) {
                outcomes = outcomes.updateIn([mostBalancedOutcomeId, 'isHeader'], function () { return true; });
            }
        });
    };
    for (var i = 0; i < matchIds.length; i++) {
        _loop_3(i);
    }
    return outcomes;
}



// WEBPACK FOOTER //
// ./src/reducers/entities/outcomesHeadersReducer.js